module.exports = __webpack_public_path__ + "static/media/view hw.82163f00.svg";